import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
// Add CSS variables for brand colors
const styleElement = document.createElement('style');
styleElement.textContent = `
:root {
  --navy: #022856;
  --sky: #0B3261;
  --teal: #1BA6C8;
  --gray: #F4F6F8;
  --dark: #0E1424;
  --text: #1A2433;
  --muted: #6B7280;
  --maxw: 1200px;
  --radius: 16px;
  --shadow: 0 6px 24px rgba(0,0,0,.08);
}
.dark {
  --text: #F4F6F8;
  --muted: #9CA3AF;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fade-in {
  animation: fadeIn 0.3s ease-out forwards;
}
html, body, #root {
  height: 100%;
  margin: 0;
  padding: 0;
}
`;
document.head.appendChild(styleElement);
// Set page title
document.title = 'COSMO IMAGE AVIATION – Global Freight Logistics & Aviation Technology Solutions';
// Add viewport meta tag for responsive design
const viewportMeta = document.createElement('meta');
viewportMeta.name = 'viewport';
viewportMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=5.0';
document.head.appendChild(viewportMeta);
// Add theme color
const themeColorMeta = document.createElement('meta');
themeColorMeta.name = 'theme-color';
themeColorMeta.content = '#022856';
document.head.appendChild(themeColorMeta);
// Add comprehensive meta tags for SEO
const metaTags = [{
  name: 'description',
  content: 'COSMO IMAGE AVIATION PTE. LTD. (UEN 202312119R) - Leading provider of global freight logistics, air cargo solutions, aviation IT systems, and security technology in Singapore. Expert management consultancy for supply chain optimization.'
}, {
  name: 'keywords',
  content: 'freight logistics Singapore, air cargo services, aviation technology, cargo consolidation, customs compliance, supply chain consultancy, aviation IT solutions, aviation security, multimodal transport, freight forwarding, COSMO IMAGE AVIATION, Super Platform AI'
}, {
  name: 'author',
  content: 'COSMO IMAGE AVIATION PTE. LTD.'
}, {
  name: 'robots',
  content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
}, {
  name: 'googlebot',
  content: 'index, follow'
}, {
  name: 'language',
  content: 'English'
}, {
  name: 'geo.region',
  content: 'SG'
}, {
  name: 'geo.placename',
  content: 'Singapore'
}, {
  name: 'geo.position',
  content: '1.297;103.8536'
}, {
  name: 'ICBM',
  content: '1.297, 103.8536'
},
// Open Graph tags
{
  property: 'og:site_name',
  content: 'COSMO IMAGE AVIATION'
}, {
  property: 'og:title',
  content: 'COSMO IMAGE AVIATION – Global Freight Logistics & Aviation Technology'
}, {
  property: 'og:description',
  content: 'Leading provider of freight logistics, air cargo solutions, aviation IT systems, and management consultancy services in Singapore. Delivering beyond borders with excellence.'
}, {
  property: 'og:type',
  content: 'website'
}, {
  property: 'og:url',
  content: 'https://www.cosmoimageaviation.com/'
}, {
  property: 'og:image',
  content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cw3ea4867NqajmUxwmCcxJ/Logo_-_Company_-_HD.png'
}, {
  property: 'og:image:width',
  content: '1200'
}, {
  property: 'og:image:height',
  content: '630'
}, {
  property: 'og:image:alt',
  content: 'COSMO IMAGE AVIATION Logo'
}, {
  property: 'og:locale',
  content: 'en_SG'
},
// Twitter Card tags
{
  name: 'twitter:card',
  content: 'summary_large_image'
}, {
  name: 'twitter:title',
  content: 'COSMO IMAGE AVIATION – Global Freight Logistics & Aviation Technology'
}, {
  name: 'twitter:description',
  content: 'Leading provider of freight logistics, air cargo solutions, aviation IT systems, and management consultancy services in Singapore.'
}, {
  name: 'twitter:image',
  content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cw3ea4867NqajmUxwmCcxJ/Logo_-_Company_-_HD.png'
}, {
  name: 'twitter:image:alt',
  content: 'COSMO IMAGE AVIATION Logo'
}];
// Add canonical link
const canonicalLink = document.createElement('link');
canonicalLink.rel = 'canonical';
canonicalLink.href = 'https://www.cosmoimageaviation.com/';
document.head.appendChild(canonicalLink);
// Add alternate language links
const alternateLinkEN = document.createElement('link');
alternateLinkEN.rel = 'alternate';
alternateLinkEN.hreflang = 'en';
alternateLinkEN.href = 'https://www.cosmoimageaviation.com/';
document.head.appendChild(alternateLinkEN);
// Add meta tags to head
metaTags.forEach(meta => {
  const metaElement = document.createElement('meta');
  const key = meta.property ? 'property' : 'name';
  metaElement.setAttribute(key, meta[key]);
  metaElement.setAttribute('content', meta.content);
  document.head.appendChild(metaElement);
});
// Enhanced JSON-LD structured data
const structuredData = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'COSMO IMAGE AVIATION PTE. LTD.',
  legalName: 'COSMO IMAGE AVIATION PTE. LTD.',
  url: 'https://www.cosmoimageaviation.com/',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cw3ea4867NqajmUxwmCcxJ/Logo_-_Company_-_HD.png',
  foundingDate: '2023-03-30',
  description: 'Leading provider of global freight logistics, air cargo solutions, aviation IT systems, security technology, and management consultancy services in Singapore.',
  slogan: 'Delivering Beyond Borders, Managing with Excellence',
  address: [{
    '@type': 'PostalAddress',
    streetAddress: '1 Liang Seah Street, #02-02',
    addressLocality: 'Singapore',
    postalCode: '189022',
    addressCountry: 'SG'
  }, {
    '@type': 'PostalAddress',
    streetAddress: '115 Airport Cargo Road, #01-01 & #01-06, Cargo Agents Building C',
    addressLocality: 'Singapore',
    postalCode: '819466',
    addressCountry: 'SG'
  }],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+65-8126-6622',
    contactType: 'Customer Service',
    areaServed: 'SG',
    availableLanguage: ['English']
  },
  email: 'contact@cosmoimageaviation.co',
  telephone: '+65-8126-6622',
  faxNumber: '+65-6234-3152',
  sameAs: ['https://www.linkedin.com/company/cosmoimageaviation', 'https://www.facebook.com/cosmoimageaviation'],
  areaServed: {
    '@type': 'GeoCircle',
    geoMidpoint: {
      '@type': 'GeoCoordinates',
      latitude: '1.297',
      longitude: '103.8536'
    }
  },
  makesOffer: [{
    '@type': 'Offer',
    itemOffered: {
      '@type': 'Service',
      name: 'Air Cargo & Charter Solutions',
      description: 'Specialized air freight services for time-sensitive and high-value shipments with global charter capabilities.'
    }
  }, {
    '@type': 'Offer',
    itemOffered: {
      '@type': 'Service',
      name: 'Aviation IT Solutions',
      description: 'Specialized IT services for the aviation industry including flight management systems and maintenance tracking software.'
    }
  }, {
    '@type': 'Offer',
    itemOffered: {
      '@type': 'Service',
      name: 'Aviation Security Technology',
      description: 'Comprehensive security solutions including advanced screening systems and cybersecurity for aviation networks.'
    }
  }, {
    '@type': 'Offer',
    itemOffered: {
      '@type': 'Service',
      name: 'Supply Chain Advisory',
      description: 'Strategic consulting to optimize supply chain operations and reduce costs.'
    }
  }]
};
const scriptElement = document.createElement('script');
scriptElement.type = 'application/ld+json';
scriptElement.textContent = JSON.stringify(structuredData);
document.head.appendChild(scriptElement);
// WebSite JSON-LD (enables Google Sitelinks Search Box)
const websiteData = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'COSMO IMAGE AVIATION',
  alternateName: 'COSMO IMAGE AVIATION PTE. LTD.',
  url: 'https://www.cosmoimageaviation.com/',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.cosmoimageaviation.com/?s={search_term_string}',
    'query-input': 'required name=search_term_string'
  }
};
const websiteScript = document.createElement('script');
websiteScript.type = 'application/ld+json';
websiteScript.textContent = JSON.stringify(websiteData);
document.head.appendChild(websiteScript);
// LocalBusiness JSON-LD (helps Google Maps & local SEO)
const localBusinessData = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': 'https://www.cosmoimageaviation.com/#localbusiness',
  name: 'COSMO IMAGE AVIATION PTE. LTD.',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cw3ea4867NqajmUxwmCcxJ/Logo_-_Company_-_HD.png',
  url: 'https://www.cosmoimageaviation.com/',
  telephone: '+65-8126-6622',
  email: 'contact@cosmoimageaviation.co',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '1 Liang Seah Street, #02-02',
    addressLocality: 'Singapore',
    postalCode: '189022',
    addressCountry: 'SG'
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 1.297,
    longitude: 103.8536
  },
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '09:00',
    closes: '18:00'
  },
  priceRange: '$$'
};
const localBusinessScript = document.createElement('script');
localBusinessScript.type = 'application/ld+json';
localBusinessScript.textContent = JSON.stringify(localBusinessData);
document.head.appendChild(localBusinessScript);
render(<AppRouter data-id="element-261" />, document.getElementById('root'));